export default "__VITE_ASSET__76aec4c5__"